/*
 * Stops a drag on a carousel from opening the card underneath.
 *
 * Swiper has its own click prevention, but it depends on Swiper's internal
 * state and was still letting clicks through. This is a plain guard that sits
 * in front of everything.
 *
 * It works by remembering where the pointer went down and comparing that with
 * where the click lands. A click that lands more than a few pixels from where
 * the press started was a drag, so it is swallowed. Nothing here depends on
 * move events firing, which matters because the browser stops sending those
 * the moment it decides a gesture is a drag.
 *
 * Listening on the document in the capture phase means this runs before any
 * handler on the card and before the browser follows the link, and it keeps
 * working for rows built after the page has loaded.
 */
(function () {
  'use strict';

  var ROWS = '.buy-again-slider, .featured-blocks-slider, .trending-now__list';

  // Enough to ignore the small wobble of an ordinary click, small enough that
  // any deliberate drag counts.
  var MOVED_ENOUGH = 8;

  var downX = null;
  var downY = null;

  function rowUnder(target) {
    return target && target.closest ? target.closest(ROWS) : null;
  }

  function remember(x, y) {
    downX = x;
    downY = y;
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (!rowUnder(event.target)) return;
      remember(event.clientX, event.clientY);
    },
    true
  );

  // A stand-in for browsers that send touch events without pointer events.
  document.addEventListener(
    'touchstart',
    function (event) {
      if (!rowUnder(event.target)) return;
      var touch = event.changedTouches && event.changedTouches[0];
      if (touch) remember(touch.clientX, touch.clientY);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (downX === null) return;
      if (!rowUnder(event.target)) return;

      var travelled =
        Math.abs(event.clientX - downX) > MOVED_ENOUGH ||
        Math.abs(event.clientY - downY) > MOVED_ENOUGH;

      downX = null;
      downY = null;

      if (!travelled) return; // A real click - let it open the card.

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
})();
